module.exports = __webpack_public_path__ + "img/SKILLNGYELLOW-LOGO-MARK@300x.5d44d06e.png";